export default __webpack_public_path__ + "static/media/unpin_blue.4e13c96e.svg";